import React from 'react';
import { Form, InputNumber, Checkbox } from 'antd';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';

import AddEditStore from './store';

@observer
class SubscriptionSettings extends React.Component {
  render() {
    const data = toJS(AddEditStore.clientInfo);
    return (
      <Form name="subscription-settings">
        <Form.Item label="Appointment Confirmed Due Days">
          <InputNumber
            size="large"
            onChange={AddEditStore.handleFieldChange(
              'AppointmentBookingReminderDueDay',
            )}
            value={data.AppointmentBookingReminderDueDay}
          />
        </Form.Item>
        <Form.Item label="Report Completed Due Days">
          <InputNumber
            size="large"
            onChange={AddEditStore.handleFieldChange(
              'ReportCompletionReminderDueDay',
            )}
            value={data.ReportCompletionReminderDueDay}
          />
        </Form.Item>
        <div className="fluid-field subscribe-box">
          <Checkbox
            checked={data.SubscribeToInvoiceReminders}
            onChange={AddEditStore.handleChecked('SubscribeToInvoiceReminders')}
          >
            Overdue Invoice Reminders
          </Checkbox>
          <Checkbox
            onChange={AddEditStore.handleChecked('SubscribeToPromotions')}
            checked={data.SubscribeToPromotions}
          >
            Receive Promotions
          </Checkbox>
        </div>
      </Form>
    );
  }
}

export default SubscriptionSettings;
